import { render, staticRenderFns } from "./cgzn.vue?vue&type=template&id=b1c9f32c&scoped=true&"
import script from "./cgzn.vue?vue&type=script&lang=js&"
export * from "./cgzn.vue?vue&type=script&lang=js&"
import style0 from "./cgzn.vue?vue&type=style&index=0&id=b1c9f32c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c9f32c",
  null
  
)

export default component.exports